"use client";
import { useTranslations } from "next-intl";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useState } from "react";
import { Logo } from "../ui/Logo";

function getSiteMapLink(path: string): string {
  const hostname = window.location.hostname;
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return `https://yammrefund.com${path}`;
  }
  const parts = hostname.split(".");
  const rootDomain = parts.length >= 2 ? parts.slice(-2).join(".") : hostname;
  return `https://${rootDomain}${path}`;
}

export function Footer() {
  const t = useTranslations("Footer");
  const [privacyHref, setPrivacyHref] = useState("/privacy-and-policy");
  const [termsHref, setTermsHref] = useState("/terms-and-conditions");
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    setPrivacyHref(getSiteMapLink("/privacy-and-policy"));
    setTermsHref(getSiteMapLink("/terms-and-conditions"));
  }, []);

  return (
    <footer className="bg-slate-950 text-slate-400 py-12 border-t border-slate-900">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-6">
        <div className="flex items-center">
          <Logo variant="light" size="sm" className="h-8" />
        </div>
        <p className="text-sm">
          &copy; {currentYear} {t("copyright")}
        </p>

        <div className="flex gap-6 text-sm font-medium">
          <Link
            target="_blank"
            href={privacyHref}
            className="hover:text-white transition-colors"
          >
            {t("privacy")}
          </Link>
          <Link
            target="_blank"
            href={termsHref}
            className="hover:text-white transition-colors"
          >
            {t("terms")}
          </Link>
          <a
            href="mailto:info@yamm.sa"
            target="_blank"
            className="hover:text-white transition-colors"
          >
            {t("contact")}
          </a>
        </div>
      </div>
    </footer>
  );
}
